export default [
    {
        value: 'active',
        text: 'Active',
    },
    {
        value: 'inactive',
        text: 'Inactive',
    }
];



// WEBPACK FOOTER //
// ./src/containers/Employee/fields/statuses.js